<template>
    <div 
        class="connection-notice" 
        v-if="!isOnline"
    >
        <i class="fas fa-exclamation-triangle" /> You are offline, you will not be able to save data until you come back online.
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            isOnline: true,
        }
    },
    mounted: function () {
        window.addEventListener('online', this.updateStatus);
        window.addEventListener('offline', this.updateStatus);
    },
    methods: {
        updateStatus: function () {
            this.isOnline = navigator.onLine;
            this.$emit('change', this.isOnline);
        }
    }
}
</script>

<style scoped lang="scss">
    .connection-notice {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #cb2400;
        padding: 10px;
        color: #ffffff;
        z-index: 9999;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ConnectionComponent.vue